import { useQuery } from '@tanstack/react-query';

const useUniversalOnboardingFeatureFlag = () => {
  const { data: isMfeEnabled = false, isLoading, error, isError } = useQuery({
    queryKey: ['universal-onboarding-feature-flag'],
    queryFn: () => {
      return new Promise((resolve, reject) => {
        const cachedValue = window.envConfig?.UNIVERSAL_ONBOARDING_SERVICE_ENABLED;
        
        if (cachedValue !== undefined) {
          // Normalize flag to boolean: handle string "true"/"false" and boolean values
          const isEnabled = typeof cachedValue === 'string'
            ? cachedValue.toLowerCase() === 'true'
            : Boolean(cachedValue);
          resolve(isEnabled);
        } else {
          reject(new Error('EnvConfig not ready'));
        }
      });
    },
    retry: 8,
    retryDelay: (attemptIndex) => Math.min(100 * Math.pow(2, attemptIndex), 1000),
    staleTime: Infinity,
    cacheTime: Infinity,
  });

  return { 
    /** @type {boolean} Whether Universal Onboarding MFE is enabled and should be rendered */
    isMfeEnabled, 
    /** @type {boolean} Whether the feature flag check is still in progress */
    isLoading,
    /** @type {boolean} Whether there was an error checking the feature flag */
    isError,
    /** @type {Error|null} The error object if feature flag check failed */
    error: isError ? error : null
  };
};

export default useUniversalOnboardingFeatureFlag;
